import { Component } from "@angular/core";
import { ProductImageZoomTriggerComponent } from "@spartacus/product/image-zoom/components";
import { ICON_TYPE } from "../../../../../../custom/icons/icon.model";

@Component({
  selector: 'cx-product-image-zoom-trigger',
  templateUrl: 'custom-product-image-zoom-trigger.component.html',
  styleUrls: ['custom-product-image-zoom-trigger.component.scss'],
  standalone: false
})
export class CustomProductImageZoomTriggerComponent extends ProductImageZoomTriggerComponent {
  iconTypes = ICON_TYPE
}
